module.exports = __webpack_public_path__ + "static/rules_ats-7b65c5d01e279de4093f18c16220a5cc.png";